module.exports = __webpack_public_path__ + "images/emoji/sound.47a8519a164b59d7327d.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/sound.png
// module id = FEMi
// module chunks = 2